import { baseUrl } from "../../../shared/config";
import { useStudentTracksPanel } from "../api/getStudentTrackPanel";
import SideBarSection from "./SideBarSection";
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@mui/material";
export default function StudentTracksPanel({ studentId }) {
  const { data } = useStudentTracksPanel({ studentId });

  return (
    <SideBarSection title={"Trilhas concluídas"}>
      <List className="user_info_section_tracks">
        {data?.map((track) => {
          return (
            <ListItem>
              <ListItemAvatar>
                <Avatar
                  src={`${baseUrl}/membros/fotos/${track.fotoTrilha}`}
                ></Avatar>
              </ListItemAvatar>
              <ListItemText>{track.nomeTrilha}</ListItemText>
            </ListItem>
          );
        })}
      </List>
    </SideBarSection>
  );
}
